<div class="page-header">
  <div>
    <h1>{{ t('NgoSettingsLink') }}</h1>
    <p>{{ t('HubSettingsIntro') }}</p>
  </div>
</div>

@if (error) {
  <p class="message error">{{ error }}</p>
}
@if (success) {
  <p class="message success">{{ success }}</p>
}
@if (loading) {
  <p>{{ t('HubSettingsLoading') }}</p>
}

@if (!loading && settings && ngo) {
  @if (settings.permissions.admin) {
    <form class="card settings-card form-grid" (ngSubmit)="saveSettings()">
      <h2>{{ t('EditNgoTitlePrefix') }}{{ ngo.name }}{{ t('EditNgoTitlePostfix') }}</h2>
      <div class="form-grid two-columns">
        <label><span class="field-label">{{ t('NgoNameLabel') }} <hub-help-tooltip [text]="t('HubNgoNameHelp')"></hub-help-tooltip></span><input name="name" [(ngModel)]="ngo.name"></label>
        <label><span class="field-label">{{ t('CorporateColorLabel') }} <hub-help-tooltip [text]="t('HubCorporateColorHelp')"></hub-help-tooltip></span><input name="color" type="color" [(ngModel)]="ngo.color"></label>
        <label><span class="field-label">{{ t('HubCustomSelfserviceDomainShortLabel') }} <hub-help-tooltip [text]="t('HubCustomSelfserviceDomainHelp')"></hub-help-tooltip></span><input name="domain" [(ngModel)]="ngo.customSelfserviceDomain" placeholder="selfservice.example.com"></label>
        <label><span class="field-label">{{ t('HubCoverTheFeesShortLabel') }} <hub-help-tooltip [text]="t('HubCoverTheFeesHelp')"></hub-help-tooltip></span><input name="fees" type="number" step="0.01" min="0" [(ngModel)]="ngo.coverTheFeesPercentage"></label>
      </div>
      <label><span class="field-label">{{ t('NgoLogoLabel') }} <hub-help-tooltip [text]="t('HubNgoLogoHelp')"></hub-help-tooltip></span><input #logoInput name="logoImage" type="file" accept=".png,.svg,image/png,image/svg+xml" (change)="onLogoSelected($event)"></label>
      @if (ngo.logoUrl) {
        <img class="settings-logo" [src]="ngo.logoUrl" [alt]="ngo.name">
      }
      <h2>{{ t('UserSessionConfiguration') }}</h2>
      <label class="checkbox-label"><input name="usesLoginCookies" type="checkbox" [(ngModel)]="ngo.usesLoginCookies"> <span class="field-label">{{ t('HubUseLoginCookiesShortLabel') }} <hub-help-tooltip [text]="t('HubUseLoginCookiesHelp')"></hub-help-tooltip></span></label>
      <label><span class="field-label">{{ t('HubLoginCookiesDurationShortLabel') }} <hub-help-tooltip [text]="t('HubLoginCookiesDurationHelp')"></hub-help-tooltip></span><input name="duration" type="number" min="0" [(ngModel)]="ngo.loginCookiesDuration"></label>
      <h2>{{ t('PayrexxIntegrationTitle') }}</h2>
      <div class="form-grid two-columns">
        <label><span class="field-label">{{ t('PayrexxUrlLabel') }} <hub-help-tooltip [text]="t('HubPayrexxUrlHelp')"></hub-help-tooltip></span><input name="payrexxUrl" [(ngModel)]="ngo.payrexxUrl"></label>
        <label><span class="field-label">{{ t('PayrexxTokenLabel') }} <hub-help-tooltip [text]="t('HubPayrexxTokenHelp')"></hub-help-tooltip></span><input name="payrexxToken" [(ngModel)]="payrexxToken" [placeholder]="ngo.payrexxTokenConfigured ? t('HubKeepCurrentTokenPlaceholder') : ''"></label>
      </div>
      <h2>{{ t('DynamicsIntegrationTitle') }}</h2>
      <div class="form-grid">
        <label><span class="field-label">{{ t('DynamicsUserLoginWebhookLabel') }} <hub-help-tooltip [text]="t('HubDynamicsUserLoginWebhookHelp')"></hub-help-tooltip></span><input name="loginWebhook" [(ngModel)]="ngo.dynamicsUserLoginWebhook"></label>
        <label><span class="field-label">{{ t('DynamicsUserActionsWebhookLabel') }} <hub-help-tooltip [text]="t('HubDynamicsUserActionsWebhookHelp')"></hub-help-tooltip></span><input name="userActionsWebhook" [(ngModel)]="ngo.dynamicsUserActionsWebhook"></label>
        <label><span class="field-label">{{ t('DynamicsNgoUserActionsWebhookLabel') }} <hub-help-tooltip [text]="t('HubDynamicsNgoUserActionsWebhookHelp')"></hub-help-tooltip></span><input name="ngoActionsWebhook" [(ngModel)]="ngo.dynamicsNgoUserActionsWebhook"></label>
        <label><span class="field-label">{{ t('DynamicsApiActionsWebhookLabel') }} <hub-help-tooltip [text]="t('HubDynamicsApiActionsWebhookHelp')"></hub-help-tooltip></span><input name="apiActionsWebhook" [(ngModel)]="ngo.dynamicsApiActionsWebhook"></label>
        <label><span class="field-label">{{ t('DynamicsApiActionsSecretLabel') }} <hub-help-tooltip [text]="t('HubDynamicsApiActionsSecretHelp')"></hub-help-tooltip></span><input name="apiSecret" [(ngModel)]="dynamicsApiActionsSecret" [placeholder]="ngo.dynamicsApiActionsSecretConfigured ? t('HubKeepCurrentSecretPlaceholder') : ''"></label>
      </div>
      <button class="primary-button" type="submit"><wa-icon name="floppy"></wa-icon>{{ t('EditNgoButton') }}</button>
    </form>
  }
  @if (settings.permissions.translator) {
    <section class="card settings-card">
      <h2>{{ t('LanguageConfiguration') }}</h2>
      <table class="table">
        <thead><tr><th>{{ t('LanguageShortCode') }}</th><th>{{ t('LanguageName') }}</th><th></th></tr></thead>
        <tbody>
          @for (language of settings.languages; track language) {
            <tr>
              <td [attr.data-label]="t('LanguageShortCode')">{{ language.code }}</td>
              <td [attr.data-label]="t('LanguageName')"><input [(ngModel)]="language.name" [name]="'language-' + language.code" (change)="updateLanguage(language.code, language.name)"></td>
              <td data-label=""><button class="danger-button" type="button" (click)="deleteLanguage(language.code)">{{ t('delete') }}</button></td>
            </tr>
          }
        </tbody>
      </table>
      <form class="inline-form add-language" (ngSubmit)="addLanguage()">
        <input name="shortCode" [(ngModel)]="newLanguageCode" [placeholder]="t('LanguageShortCode')">
        <input name="languageName" [(ngModel)]="newLanguageName" [placeholder]="t('LanguageName')">
        <button class="primary-button" type="submit">{{ t('AddLanguage') }}</button>
      </form>
    </section>
  }
}
